<template>
    <div v-if="student" class="container my-4">
      <h1 class="text-center text-primary mb-4">View QR Code</h1>
      <div class="card mx-auto" style="max-width: 500px;">
        <div class="card-body text-center">
          <h5 class="card-title">Wave Code: {{ student.wave_code }}</h5>
          <h5 class="card-title">Wave QR Code: {{ student.wave_qr_code }}</h5>
          <p class="card-text">QR Status ID: {{ student.qr_status_id }}</p>
          <p class="card-text">Created At: {{ formatDate(student.created_at) }}</p>
          <p class="card-text">Updated At: {{ formatDate(student.updated_at) }}</p>
  
          <!-- QR Code Display -->
          <div v-if="student.wave_qr_code">
            <qrcode-vue
              :value="student.wave_qr_code"
              :size="200"
              class="qr-code"
              render-as="canvas"
            />
          </div>

  
          <!-- Download Button -->
          <div class="downloadBtn" v-if="student.wave_qr_code">
            <button class="btn btn-primary" @click="downloadQRCode">
              <i class="bi bi-download"></i> Download QR Code
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Fallback Message -->
    <div v-else class="text-danger my-3">
            <p>No QR code available</p>
          </div>
  </template>
  
<script>
import QrcodeVue from "qrcode.vue";

export default {
  components: {
    QrcodeVue,
  },
  props: {
    student: {
      type: [Object, null], // Accepts both Object and null
      required: true,
    },
  },
  methods: {
    formatDate(dateString) {
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(dateString).toLocaleDateString(undefined, options);
    },
    downloadQRCode() {
      const canvas = document.querySelector(".qr-code"); // Select the specific QR code canvas
      if (!canvas) {
        alert("QR Code not available for download.");
        return;
      }
      const dataUrl = canvas.toDataURL("image/png"); // Convert canvas to data URL
      const link = document.createElement("a"); // Create a link element
      link.href = dataUrl; // Set link href to data URL
      // link.download = "QRCode.png"; // Set the download file name
      // link.download = `${this.student.wave_qr_code} QRCode.png`; // Dynamic file name
      link.download = `${this.student.wave_qr_code} ${this.student.wave_code} QRCode.png`; // both values in filename
      link.click(); // Trigger download
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: none;
}

.card-title {
  font-weight: 600;
  color: #0d6efd;
}

.card-body {
  padding: 20px;
}

.qr-code {
  margin-top: 15px;
}

.downloadBtn button {
  font-weight: 500;
}
</style>
